<template>
<v-dialog
    v-model="dialog"
    max-width="920"
    v-if="params != null"
>
    <v-card>
        <v-card-title>{{params.title}}</v-card-title>

        <v-card-text>
            <p
                v-if="params.content_before != null"
                v-html="params.content_before"
            />

            <v-select
                v-if="type == 'select'"
                :label="params.select_label"
                :items="params.choices"
                v-model="value"
                :multiple="params.multiple"
            />

            <m-edit-select-objects
                v-else-if="type == 'select_object_type'"
                :label="params.select_label"
                :type="params.select_object_type"
                v-model="value"
            />

            <div
                v-else-if="type == 'radio'"
            >
                <v-radio-group
                    v-model="value"
                >
                    <v-radio 
                        v-for="(item, index) in params.choices"
                        :key="'rc_'+index"
                        :label="item.text"
                        :value="item.value"
                    />
                </v-radio-group>
            </div>

            <div
                v-else-if="type == 'check-box'"
            >
                <div
                    style="margin-bottom: 25px"
                >
                    <v-checkbox
                        v-for="(item, index) in params.choices"
                            :key="'cb_'+index"
                            :label="item.text"
                            :value="item.value"
                            v-model="value"
                            style="margin-bottom: -35px"
                    />
                </div>

                 <a
                    v-if="params.show_select_all"
                    v-on:click="onClickSelectAll()"
                    style="margin-right: 15px"
                 >
                    Select All
                 </a>

                 <a
                    v-if="params.show_select_all"
                    v-on:click="onClickSelectNone()"
                 >
                    Select None
                 </a>

            </div>
               

             <p
                v-if="params.content_after != null"
                v-html="params.content_after"
            />
            
        </v-card-text>

        <v-card-actions>
            <v-btn
                text
                @click="onClickUnset"
                v-if="params.unset_label != null"
            >
                {{params.unset_label}}
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            {{this.params.cancel_text ?? 'Cancel'}}
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
                :disabled="!is_valid"
            >
            {{this.params.ok_text ?? 'Ok'}}
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            params: null,
            items: [],
            value: null,
        }
    },

    created () {
        this.$event_bus.$on('pick_dialog', this.showDialog);
    },

    beforeDestroy () {
        this.$event_bus.$off('pick_dialog',this.showDialog);
    },

    methods: {

        showDialog(params)
        {
            this.params = params;

            this.value = this.$rc.getDeep(this.params, 'initial_value');

            if ( this.params.choices == 'timezone' )
            {
                this.params.choices = this.$rc.commonTimeZones();
            }

            if ( this.type == 'check-box' && this.value == null )
                this.value = [];

            if ( this.params.choices == 'lists' )
            {
                this.$rc.rest({
                    'spinner': false,
                    'endpoint': 'LIST: /api/v1/lists/choose-org-list',
                
                    'params' : {
                            'organization_id': this.$rc.$state.getOrganizationId(),
                            'include_auto_lists': false,
                        },
                
                    'on_success': (data) => {
                            this.params.choices = data.results;
                            this.dialog = true;
                        },
                
                    'on_error': 'Unable get lists',
                });
            }
            else if ( this.params.choices == 'bulk_message_group' )
            {
                this.$rc.rest({
                    'spinner': false,
                    'endpoint': 'LIST: /api/v1/autocomplete/bulk_message_group',
                
                    'params' : {
                            'organization_id': this.$rc.$state.getOrganizationId(),
                        },
                
                    'on_success': (data) => {
                            this.params.choices = data.results;
                            this.dialog = true;
                        },
                
                    'on_error': 'Unable get bulk message analytics groups',
                });
            } 
            else 
            {
                this.dialog = true;
            }
        },

        onClickUnset()
        {
            this.dialog = false;
            this.params.on_ok(null);
        },

        onOk()
        {
            this.dialog = false;
            this.params.on_ok(this.value);
        },

        onCancel()
        {
            this.dialog = false;

            if ( this.params.on_cancel != null )
                this.params.on_cancel();
        },

        onClickSelectAll()
        {
            this.value = this.params.choices.map((el) => el.value);
        },

        onClickSelectNone()
        {
            this.value = [];
        },

    },

    computed: {
        type() {
            let ret = this.$rc.getDeep(this.params,'type');

            if ( ret == null ) 
                return 'select';

            ret = ret.toLowerCase();

            if ( ret == 'cb' ) ret = 'check-box';
            if ( ret == 'check_box' ) ret = 'check-box';

            if ( ret == 'rb' ) ret = 'radio';
            if ( ret == 'radio-button' ) ret = 'radio';

            if ( this.params.multiple && ret == 'radio' ) ret = 'check-box';
            if ( !this.params.multiple && ret == 'check-box' ) ret = 'radio';

            return ret;
        },

        is_valid()
        {
            if ( this.params.allow_no_selection ) return true;

            if ( this.value == null ) return false;
            if ( Array.isArray(this.value) && this.value.length == 0 ) return false;

            return true;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>